module.exports = __webpack_public_path__ + "d495c5f23f18e46c789464a27cdfb3c3.png";